import styled from 'styled-components'

export const StyledAsterix = styled.span`
  color: ${({ theme }) => theme.palette.statusRed};
  padding-left: 0.2rem;
`
